import React, { useContext } from "react";
import "./Works.css";
import komals from "../../img/komals.jpg";
import komali from "../../img/komli.jpg";
import komalll from "../../img/komalll.jpg";
// import Amazon from "../../img/sandeep.png";
import Shopify from "../../img/Shopify.png";
import Facebook from "../../img/Facebook.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import {Link} from 'react-scroll'
const Works = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  return (
    <div className="works" id="works">
      {/* left side */}
      <div className="w-left">
        <div className="awesome">
          {/* dark Mode */}
          <span style={{ color: darkMode ? "white" : "" }}>
            Works for All these
          </span>
          <span>Software</span>
          <spane>
           E-commerce Application
            <br />
           Login Page Project
            <br />
           Familiar with Reactjs Project
            <br />
          Online Calculator
          </spane>
          <Link to="contact" smooth={true} spy={true}>
            <button className="button s-button">Hire Me</button>
          </Link>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>

        {/* right side */}
      </div>
      <div className="w-right">
        <motion.div
          initial={{ rotate: 45 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: "-40px" }}
          transition={{ duration: 3.5, type: "spring" }}
          className="w-mainCircle"
        >
          <div className="w-secCircle">
            <img src={komals} alt="" />
        
          </div>
          <div className="w-secCircle">
            <img src={komali} alt="" />
           
          </div>
          <div className="w-secCircle">
            {/* <img src={komalll} alt="" /> */}
            Komal Chhipa
            
          </div>{" "}
          <div className="w-secCircle">
            <img src={komalll} alt="" />
            
          </div>
          <div className="w-secCircle">
            {/* <img src={Facebook} alt="" /> */}
            Python Dev.
          </div>
        </motion.div>
        {/* background Circles */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
